export const SET_DATA = 'reads/SET_DATA'
export const SET_IS_FETCHING = 'reads/SET_IS_FETCHING'
